//currency-switcher
$(document).ready(function(){
  $("body").delegate("a#switchCountry", "click", function(e){
      e.preventDefault();
    $("#switchCountryModal").modal("show");
  });
  $('.view-cart span a').click(function(e){
      e.preventDefault();
  var cartpage=$(this).attr('href');
    window.location.href = cartpage;
    });
  });
  $(".currency-switcher").click(function(){
      document.querySelector(".cutliver-drawer.currency-cwitcher").classList.add("side--active");
  }); 
  
  $('.cutliver-drawer-header-right').click(function(){
      document.querySelector(".cutliver-drawer.currency-cwitcher").classList.remove("cutliver-drawer--active");
  }); 
  // search Drawer
  $(document).ready(function(){
    $('.open_drawer  button.btn.btn-search, .search_form.open_drawer  input[type="search"] , .search-icon.open_drawer, form#newform input[type="search"]').bind('click', function(event){
      event.preventDefault();
      document.querySelector(".cutliver-drawer.search-drawer").classList.add("side--active");
      document.querySelector(".cutliver-drawer.search-drawer .cutliver-box").classList.add("side--overlay");
      $("header.cutliver-drawer-header .search_form input#Search").focus();
    }); 
    $('.cutliver-drawer-header-right').click(function(){
      document.querySelector(".cutliver-drawer.search-drawer").classList.remove("side--active");
      document.querySelector(".cutliver-drawer.search-drawer .cutliver-box").classList.remove("side--overlay");
      $(".search_form.open_drawer input#Search").val("");
  });
  });
  
  /*-------search-----------*/
  $(document).ready(function(){
    $( "body #move_search_page" ).on( "click", function() {
      $('button.btn.btn-search').click();
    });
    /*----load data in search ------*/
    $("body ").delegate("#next-page-load", "click", function(){
    var nextUrl = $(this).attr('data-href');
    console.log(nextUrl);
    $('#spiner_load').show();
      $('.show-more-btn').hide();
          $.ajax({
          url: nextUrl,
          type: 'GET',
          dataType: 'html',
          success: function(responseHTML){
            var data=$(responseHTML).find('.bottom-page').html();
            $('.search_product_box').append($(responseHTML).find('.search_product_box').html());
            $('.bottom-page').html(data);
          },
          complete: function() {
              $('#spiner_load').hide();
             $('.show-more-btn').show();
          }
          });
    });
    $("body ").delegate(".product-card_buttons", "click", function(){
     $(this).find('.variant-options_js').css("display", "block");
      });
    $("body ").delegate(".product-card_buttons  button.close-icon", "click", function(){
    $(this).parents('.variant-options_js').css("display", "none");
      });
  
    
  });
  
  /*--------product page---------*/
  $(document).ready(function(){
 $("body").delegate("div#find_store", "click", function(e){
      e.preventDefault();
    $('#cartdrawer_find_astore').modal('show');
 });
  $("body").delegate(".Size_guide", "click", function(e){
      e.preventDefault();
    $("#cultiver_sizeguide").modal("show");
  });
    $("body").delegate(".color-swatches .cultiver_cust_see-more", "click", function(e){
      e.preventDefault();
    $(".cultiver_color_swatch").toggleClass("cultiver_show");
  });
  
    $("body").delegate(".cultiver_zoomin_cus", "click", function(e){
      e.preventDefault();
    $("this").parents('.cultiver_image').addClass("zoom_img");
  });
  
  
     $('.product_imgaes_desktop .cultiver_image')
      // tile mouse actions
      .on('mouseover', function(){
        $(this).children('img').css({'transform': 'scale('+ $(this).attr('data-scale') +')'});
      })
  
      .on('mouseout', function(){
        $(this).children('img').css({'transform': 'scale(1)'});
      })
      .on('mousemove', function(e){
        $(this).children('img').css({'transform-origin': ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + '% ' + ((e.pageY - $(this).offset().top) / $(this).height()) * 100 +'%'});
      });
    
    });
  
  /*--convert table cm and inches--------*/
  $(document).ready(function(){
  $("input#check_cm_in").click(function(){
        var unit ='';
        if ($(this).is(':checked')){
        var unit = 'in';
        }
        else{
        var unit ="cm";
        }
    $(".cultiver_customTable table tr td").each(function (){
      var elem = $(this).find('.cultiver_table_val').text();
      if($.isNumeric(elem)) {
          if( unit == 'in'){
             /*--covert to cm---*/
              var elemm = $(this).find(".iches").attr('data-attr');
              if(elemm){
              var elem= elemm;
              }
              var elem=  (elem / 0.39370).toFixed(0);
              $(this).html('<span class="cultiver_table_val">'+elem+'</span><span> cm</span>');
          }else{
            var elem_m=  (elem * 0.39370).toFixed(0); 
              /*--covert to inches---*/
              
            var elemm=  (elem * 0.39370).toFixed(2);
              $(this).html('<span class="cultiver_table_val iches" data-attr="'+elemm+'" >'+elem_m+'</span><span> in</span>');
          }
      }
    });
  });
  
  $(".cultiver_customTable table tr td").each(function (){
    var elem = $(this).text();
    if($.isNumeric(elem)) {
            $(this).html('<span class="cultiver_table_val">'+elem+'</span><span> cm</span>');
        }
  });
    
  });
  /*--convert finish table cm and inches--------*/
  function opentab(evt, cityName) {
    var i, custtabcontent, custtablinks;
    custtabcontent = document.getElementsByClassName("custtabcontent");
    for (i = 0; i < custtabcontent.length; i++) {
      custtabcontent[i].style.display = "none";
    }
    custtablinks = document.getElementsByClassName("custtablinks");
    for (i = 0; i < custtablinks.length; i++) {
      custtablinks[i].className = custtablinks[i].className.replace(" active", "");
    }
    document.getElementById(cityName).style.display = "block";
    evt.currentTarget.className += " active";
  }
  
  // Get the element with id="defaultOpen" and click on it
  $(document).ready(function(){
  document.getElementById("defaultOpen").click();
    //$('[data-bs-target="#flush-collapseOne"]').click();
  });
  
  $(document).ready(function(){
  $("body").delegate(".product_review span.rating-review-text, body.product .product_page_review", "click", function(){
       $('html, body').animate({scrollTop: $(".okeReviews.oke-w").offset().top-10}, 1000);
  });
  });

// SJ
$(document).ready(function(){
  $(document).on('click', '#main-product-nocss form button.btn-bronze.standard-text.mt-4.featured-add-to-cart.button-primary', async function(event) {
    event.preventDefault();

    var $form = $(this).closest('form');
    var inputcheck = $(".cultiver_product_page form .radio input:checked").val();

    if (inputcheck) {
      $("span#sizeguide_error_message").hide();

      try {
        // Add product to cart
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: $form.serialize()
        });

        // Get cart data
        const cartRes = await fetch("/cart.js");
        const cart = await cartRes.json();
        updateCartItemCounts(cart.item_count);

        // Update cart drawer
        const drawerRes = await fetch("/?section_id=cart-drawer");
        const drawerText = await drawerRes.text();
        const html = document.createElement("div");
        html.innerHTML = drawerText;
        const newBox = html.querySelector(".cart-drawer").innerHTML;
        document.querySelector(".cart-drawer").innerHTML = newBox;

        addCartDrawerListeners();
        window.dispatchEvent(new CustomEvent('searchspring.recs.retarget', {}));
        openCartDrawer();

      } catch (error) {
        console.error('Error adding to cart:', error);
      }

    } else {
      $('html, body').animate({
        scrollTop: $(".product__title").offset().top - 100
      }, 1000);
      $("span#sizeguide_error_message").show();
    }
  });
});
// SJ
  
  /*-------sticky addtocard -------*/
  $(document).ready(function(){
    $( document ).on( 'click', '#sticky-bottom-product-nocss form button.btn-bronze.standard-text.mt-4.featured-add-to-cart.button-primary', function( event ) { 
        event.preventDefault();
     var inputcheck = $(".cultiver_product_page form .radio input:checked").val();
  if(inputcheck){
    errormessgaesize_hide();
    $(".cultiver_product_page form button.btn-bronze.standard-text.mt-4.featured-add-to-cart.button-primary").click();
    openCartDrawer();
  }
  else{
    $('html, body').animate({scrollTop: $(".product__title").offset().top-100}, 1000);
    errormessgaesize_show();
  }
  });
  $("input.product_requestswatch").click(function(){
      var numberOfChecked = $('input.product_requestswatch:checkbox:checked').length;
      $(".count_request_product").html(numberOfChecked);
      var isChecked = $(this).is(":checked");
      var val = $(this).val();
      if(isChecked){
            var name= $(this).attr('productname');
            if(numberOfChecked == 1){
            $('.requestswatch-sticky-bottom span.product_price p').html('<span id="'+val+'"><span>/</span>'+name+'</span>');
            }else{
            $('.requestswatch-sticky-bottom span.product_price p').append('<span id="'+val+'"><span>/</span>'+name+'</span>');
            }
      }else{
            var name= $(this).attr('productname');
            $('.requestswatch-sticky-bottom span.product_price p').find('span#'+val).remove();
      }
     errormessgaesize_hide();
  });
    //collection page request a swatch
    $( document ).on( 'click', '#sticky-bottom-collection-nocss  button.btn-bronze.standard-text.mt-4.featured-add-to-cart.button-primary', function( event ) { 
        event.preventDefault();
     var inputcheck = $("form .radio_nocss input:checked").val();
  //console.log(inputcheck);
  if(inputcheck){
    errormessgaesize_hide();
    $("form button.btn-bronze.standard-text.mt-4.featured-add-to-cart.button-primary").click();
  }
  else{
    errormessgaesize_show();
  }
  });
    
  
  function errormessgaesize_show(){
      $("span#sizeguide_error_message").show();
  }  
  function errormessgaesize_hide(){
      setTimeout(function () {
      $("span#sizeguide_error_message").hide();
      }, 500); 
  } 
  
  $( document ).on( 'click', '#select_size_cultiver', function( event ) { 
      $('html, body').animate({scrollTop: $(".product__title").offset().top-100}, 1000);
      errormessgaesize_show();
  });
    
  $('select#product-select').on('change', function() {
      var vvv = $(this).val();
      $('[value="'+vvv+'"]').click();
  });
  
  $('.variant-options input').click(function(){
    errormessgaesize_hide();
    var inputcheckurl = $(this).attr('datahref');
    if(inputcheckurl){
      console.log(inputcheckurl);
      let stateObj = { id: "100" };
                window.history.pushState(stateObj,
                    "products", inputcheckurl);
    }
     var price =$(this).attr('data-vraintprice');
    var $this = $(this);
    var comapre_price=$(this).attr('data-compareprice');
    var label =$(this).attr('label');
    $("#select_size_cultiver").html(label);  
   change_price($this,price,comapre_price)
  });
  
  function change_price($this,price,comapre_price){
    if(comapre_price){
    $this.parents(".product_card_box_js").find("span.tiny-text.prod-price.money").html(price);
    $this.parents(".product_card_box_js").find("span.tiny-text.prod-price.money").removeClass('cultivet_single_color');
    $this.parents(".product_card_box_js").find("span.compare_cultiver_price").html('<span class="tiny-text compare-price money"><strong>'+comapre_price+'</strong></span>');  
    }
    else{
    $this.parents(".product_card_box_js").find("span.tiny-text.prod-price.money").addClass('cultivet_single_color');
     $this.parents(".product_card_box_js").find("span.compare_cultiver_price").html('');
     $this.parents(".product_card_box_js").find("span.tiny-text.prod-price.money.cultivet_single_color").html(price);
    }
  }
    
  });
  
  $(document).ready(function(){
  
  var menuLinks = function(){  
    var menuLinksTop = $('.cultiver_product_page .product__title button.btn-bronze.standard-text').offset().top;  
      var scrollTop = $(window).scrollTop();  
  
      if (scrollTop > menuLinksTop) {   
          $('.sticky-bottom').addClass('sticky-bottom-active');  
      } else {
          $('.sticky-bottom').removeClass('sticky-bottom-active');   
      }
  }
  
  menuLinks();  
  
  $(window).scroll(function() {  
      menuLinks();  
  });
  });
  
  //mobile zoom in
  $(document).ready(function(){
  $("body").delegate("span.cultiver_mobile_zoomin", "click", function(e){
      e.preventDefault();
      var slideno = $(".product_mobile_device .mobile_img.slick-slide.slick-current.slick-active").attr('data-slick-index');
      $(".productimageslidermobile").slick("slickGoTo", slideno);
      $("#productimage_cutiverr").modal("show");
  });
   /* $( document ).on( 'dblclick', '.cultiver_imageeee', function( event ) { 
      console.log('hh');
      $(this).children('img').css({'transform': 'scale('+ $(this).attr('data-scale') +')'});
  });*/
   $( document ).on( 'click', '.addtocart_popup', function( event ) { 
  var productid=$(this).attr('product_id');
     $('#completelook_popup form').hide();
     $(this).parents('.product_cultiver_compete').find("#product_form_"+productid).show();
     $(this).parents('.product_cultiver_compete').find("#completelook_popup").modal("show");
  });
  
  
    
  });
  
  
  function openCity(evt, cityName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(cityName).style.display = "block";
    evt.currentTarget.className += " active";
  }
  // product cart box close 
   $( document ).on( 'click', '.product_card_box button.close-icon', function( event ) { 
          $(this).parents("span.product_card_box").find('.product-card_buttons').css("opacity", "0");
          $(this).parents("span.product_card_box").find('.variant-options_js').css("display", "none");
          $(this).parents("span.product_card_box").find('.product_hover').css("opacity", "0");
       $(this).parents("span.product_card_box").find('.c_popup').css("display", "none");
      $(this).parents(".product_card_box_js").find('.c_popup .variant-options').removesClass("cultiver_collection_vraiant"); 
      });
  
  
  //cartdrawer toggle getit together
  $( document ).on( 'click', '.icon_cartdrawer', function( event ) { 
  $(this).parents(".complete_the_look.featured-products-slider").toggle("cart_drawerr_active_nocss");
   });
  
  
  
  /*-----------bundle product select options---------*/
  $(document).ready(function(){
  /*--  select div---*/
  $('.select-menu li.option').click(function(){
    $(this).parents('.custom-select').find('.select-menu li.option').removeClass("option_active");
    $('.select-menu').removeClass("active");
    $(this).addClass('option_active');
      $(this).parents('.bundle_tbox_optin').find('select.preselectedselect option').removeAttr('selected', 'selected');
  var data = $(this).find('span.option-text').html();
    var dataa = $(this).attr('preselected');
  console.log(dataa);
     $(this).parents('.bundle_tbox_optin').find('select.preselectedselect option[preselected="'+dataa+'"]').attr('selected','selected').trigger('change');
    $(this).parents('.custom-select').find('.sBtn-text').html(data);
     $('.select-menu').removeClass("active");
  });


  $('.select-menu li.option.option_fs').click(function(){
    $(this).parents('.custom-select').find('.select-menu li.option').removeClass("option_active");
    $('.select-menu').removeClass("active");
    $(this).addClass('option_active');
     $('.select-menu').removeClass("active");
     var stockin_soldout= $(this).attr('stockin_soldout');
     var stockinsol=$(this).attr('stockinsol');
     if(stockinsol == '1'){
      $(this).parents('#cartdrawer_find_astore').find('.fs_avalibility').addClass('fs_avalibility_in');
      $(this).parents('#cartdrawer_find_astore').find('.fs_avalibility').removeClass("fs_avalibility_out");
     }else{
      $(this).parents('#cartdrawer_find_astore').find('.fs_avalibility').addClass('fs_avalibility_out');
      $(this).parents('#cartdrawer_find_astore').find('.fs_avalibility').removeClass("fs_avalibility_in");
     }
     $(this).parents('#cartdrawer_find_astore').find('.fs_avalibility span span.cltiver_gap_text').html(stockin_soldout);
  });
  
  $('.select-btn').click(function(){
  var test = $(this).attr('dd');
  if(test){
    $(this).removeAttr('dd', '1');
    $(this).parent().removeClass("active");
  }else{
  $(this).attr('dd', '1');
      $(this).parent().addClass("active");
  }
  });
  /*--  select div  closed---*/  
    
      $("select.product-form__variants").change(function(){
          var $this = $(this);
          var variant_val = $(this).find('option:selected').val();console.log(variant_val);
          var price = $(this).find('option:selected').attr("data-vraintprice");
        var pricee = $(this).find('option:selected').attr("data-vraintpricee");
          var comapre_price = $(this).find('option:selected').attr("data-compareprice");
           select_option_change_price($this,price,comapre_price);
          bundle_product_info($this,variant_val,price,pricee);
          selecteditemcount($this);
        selectoption_bundle_price($this);
      });
    
      function bundle_product_info($this,variant_val,price,pricee){
        if(variant_val){
        $this.parents('.select_option_bundleproduct').find('div#select_option_product_input').html('<input dataprice="' + pricee + '"  style="display:none;" checked type="checkbox"  name="id[]" value="' + variant_val +'">');
        } else{
        $this.parents('.select_option_bundleproduct').find('div#select_option_product_input').html(' ');
        }
      }
    
      // SJ solution that automatically removes decimals

      // old solution that have decimals------
      // function select_option_change_price($this,price,comapre_price){
      //   if(price){
      //       $this.parents('.select_option_bundleproduct').find(".select_option_money_second span.tiny-text.prod-price.money").html(price);
      //       $this.parents('.select_option_bundleproduct').find(".select_option_money_first").hide();
      //       $this.parents('.select_option_bundleproduct').find(".select_option_money_second").show();
      //       $this.parents('form').find("#bundle_product_addtocart button").removeClass('bundle-product-grey');
      //      $this.parents(".select_option_bundleproduct").find(".select_option_money_second span.tiny-text.prod-price.money").addClass('cultivet_single_color');
      //       }else{
      //       $this.parents('.select_option_bundleproduct').find(".select_option_money_first").show();
      //       $this.parents('.select_option_bundleproduct').find(".select_option_money_second").hide();
      //       }
      
      //   if(comapre_price){
      //       $this.parents('.select_option_bundleproduct').find('.select_option_money_second .compare_cultiver_price').html('<span  class="tiny-text compare-price money SJSJ"><strong>'+comapre_price+'</strong></span>');
      //       $this.parents('.select_option_bundleproduct').find('.select_option_money_second .compare_cultiver_price').show();
      //     $this.parents(".select_option_bundleproduct").find(".select_option_money_second span.tiny-text.prod-price.money").removeClass('cultivet_single_color');
      //       }
      //       else{
      //       $this.parents('.select_option_bundleproduct').find('.select_option_money_second .compare_cultiver_price').hide();
      //       }
      // }
      // old solution that have decimals------
      
      function select_option_change_price($this, price, comapre_price) {
        function removeDecimals(value) {
          if (!value) return value;
          // Remove .00 but keep .50 etc.
          return value.replace(/(\d+)\.00(?!\d)/g, "$1");
        }

        // Clean up both values
        price = removeDecimals(price);
        comapre_price = removeDecimals(comapre_price);

        if (price) {
          $this.parents('.select_option_bundleproduct').find(".select_option_money_second span.tiny-text.prod-price.money").html(price);
          $this.parents('.select_option_bundleproduct').find(".select_option_money_first").hide();
          $this.parents('.select_option_bundleproduct').find(".select_option_money_second").show();
          $this.parents('form').find("#bundle_product_addtocart button").removeClass('bundle-product-grey');
          $this.parents(".select_option_bundleproduct").find(".select_option_money_second span.tiny-text.prod-price.money").addClass('cultivet_single_color');
        } else {
          $this.parents('.select_option_bundleproduct').find(".select_option_money_first").show();
          $this.parents('.select_option_bundleproduct').find(".select_option_money_second").hide();
        }

        if (comapre_price) {
          $this.parents('.select_option_bundleproduct').find('.select_option_money_second .compare_cultiver_price').html('<span class="tiny-text compare-price money SJSJ"><strong>' + comapre_price + '</strong></span>').show();
          $this.parents(".select_option_bundleproduct").find(".select_option_money_second span.tiny-text.prod-price.money").removeClass('cultivet_single_color');
        } else {
          $this.parents('.select_option_bundleproduct').find('.select_option_money_second .compare_cultiver_price').hide();
        }
      }
      // SJ solution that automatically removes decimals
  
      function selecteditemcount($this){
            var len = $this.parents('form').find('li.select_option_bundleproduct div#select_option_product_input input').length;
            if(len > 0){
              $this.parents('form').find('span.select_option_addtocart').html('ADD '+len+' ITEMS TO CART');
            } else {
              $this.parents('form').find("#bundle_product_addtocart button").addClass('bundle-product-grey');
              $this.parents('form').find('span.select_option_addtocart').html('ADD TO CART');
            }
      }
  
       function selectoption_bundle_price($this){
         $('.second_box_price').hide();
           let total = 0;
          $this.parents('.product_card_box_js').find('.selectoption_product_layoutsecond  ul li').each(function() {
          var dataprice=$(this).find('.bundle_tbox div#select_option_product_input input').attr('dataprice');
          if(dataprice){
          total += parseInt(dataprice);
          }
          });
          console.log(total);
          if(total > 0){
             $this.parents('.product_card_box_js').find('p.first_box_price').show(); 
                var totall =((total)/100);
                var currency = '$';
                var currentCurrent = $('body.currency_fetch').attr('currency');
                if(currentCurrent === 'AUD' || currentCurrent === 'USD'){
                  var currency = '$';
                } else {
                  var currency = '£';
                }
            
                   $this.parents('.product_card_box_js').find('span.product_price p.first_box_price span.money').html(currency+''+totall);
                 $this.parents('.product_card_box_js').find('p.first_box_price .form_hide').hide();
                 $this.parents('.product_card_box_js').find('p.first_box_price span.tiny-text.compare-price.money').hide();
          }else{
          
                 $this.parents('.product_card_box_js').find('.second_box_price').show();
             $this.parents('.product_card_box_js').find('.first_box_price').hide();     
          }
      }
  
    
  
  
  $('.selectoption_product_layoutsecond .cart-drawer-quantity-selector-plus').click(function () {
      if ($(this).prev().val() < 10) {
        $(this).prev().val(+$(this).prev().val() + 1);
      }
  });
  // $('.selectoption_product_layoutsecond .cart-drawer-quantity-selector-minus').click(function () {
  //     if ($(this).next().val() > 1) {
  //       if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
  //     }
  // });
    });
$( document ).ready(function() {
  let swiper = new Swiper(".emptycartmySwiper", {
            scrollbar: {
        el: '.swiper-scrollbar',
        hide: true,
      },

            loop: true,
        });
});